import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GlobalModulesModule } from 'src/app/core/global-modules/global-modules.module';
import { QuantityPurchasedByDoctorRoutingModule } from './quantity-purchased-by-doctor-routing.module';
import { QuantityPurchasedByDoctorComponent } from './quantity-purchased-by-doctor.component';
import { QuantityPurchasedByDoctorFilterComponent } from './quantity-purchased-by-doctor-filter/quantity-purchased-by-doctor-filter.component';
import { ReportModule } from '../report.module';

@NgModule({
  imports: [
    CommonModule,
    GlobalModulesModule,
    QuantityPurchasedByDoctorRoutingModule,
    ReportModule
  ],
  declarations: [QuantityPurchasedByDoctorComponent, QuantityPurchasedByDoctorFilterComponent],
  entryComponents:[QuantityPurchasedByDoctorFilterComponent]
})
export class QuantityPurchasedByDoctorModule { }
